<template>
  <div class="cj-set">
    <div class="cj-header">
      <span
        class="cj-add"
        @click="addJoin"
      >
        <feather-icon
          icon="PlusIcon"
          size="10"
        /> связка
      </span>
    </div>
    <div
      v-for="(jp, ji) in value.joins"
      :key="ji"
      class="cj-line"
    >
      <span
        class="cj-dot"
        :class="jp.isActive ? 'cj-dot--on' : 'cj-dot--off'"
        @click="jp.isActive = !jp.isActive"
      />
      <!-- join name -->
      <span
        class="cj-word"
        :class="{ 'cj-word--empty': !hasJoin(jp) }"
        @click="open(ji)"
      >{{ joinLabel(jp) }}</span>
      <span
        class="cj-del"
        @click="removeJoin(ji)"
      >
        <feather-icon
          icon="XIcon"
          size="10"
        />
      </span>
      <!-- dropdown panel -->
      <div
        v-if="activeRow === ji"
        class="cj-panel"
      >
        <b-form-input
          :ref="'pi_' + ji"
          v-model="search"
          size="sm"
          placeholder="Поиск..."
          autocomplete="off"
          @input="onSearch"
          @keydown.esc="close"
          @keydown.enter.prevent="pickFirst(ji)"
        />
        <div
          v-if="filtered.length"
          class="cj-list"
        >
          <div
            v-for="item in filtered"
            :key="item.value"
            class="cj-opt"
            @click.stop="pick(ji, item)"
          >{{ item.text }}</div>
        </div>
        <div
          v-else-if="search"
          class="cj-empty"
        >
          Не найдено
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'
import useJwt from '@/cubus/jwt/useJwt'

let cachedJoinRef = null
let joinRefLoading = false
let joinRefCallbacks = []

export default {
  name: 'CbsJoinConstructor',
  components: { BFormInput },
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      joinRef: cachedJoinRef || [],
      activeRow: -1,
      search: '',
      source: [],
      filtered: [],
    }
  },
  created() {
    if (!cachedJoinRef) this.loadJoinRef()
  },
  mounted() {
    this._outsideClick = e => {
      if (this.activeRow >= 0 && !e.target.closest('.cj-line')) this.close()
    }
    document.addEventListener('click', this._outsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this._outsideClick)
  },
  methods: {
    // --- labels ---
    joinLabel(jp) {
      const j = jp.join
      return (j && (j.title || j.sid)) || '(связка)'
    },
    hasJoin(jp) {
      const j = jp.join
      return j && (j.title || j.sid || j.value)
    },

    // --- picker ---
    open(ji) {
      if (this.activeRow === ji) { this.close(); return }
      this.search = ''
      this.source = this.joinRef.map(r => ({ value: r.value, text: r.title || r.sid || String(r.value), _r: r }))
      this.filtered = this.source
      this.activeRow = ji
      this.$nextTick(() => {
        const ref = this.$refs[`pi_${ji}`]
        const el = Array.isArray(ref) ? ref[0] : ref
        if (el) el.focus()
      })
    },
    close() { this.activeRow = -1; this.search = ''; this.source = []; this.filtered = [] },
    onSearch() {
      if (!this.search.trim()) { this.filtered = this.source; return }
      const parts = this.search.trim().toLowerCase().split(/\s+/)
      const re = new RegExp(parts.map(p => p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('.*'))
      this.filtered = this.source.filter(i => re.test((i.text || '').toLowerCase()))
    },
    pickFirst(ji) { if (this.filtered.length) this.pick(ji, this.filtered[0]) },
    pick(ji, item) {
      const jp = this.value.joins[ji]
      const r = item._r
      this.$set(jp, 'join', r ? { value: r.value, sid: r.sid, title: r.title } : { value: item.value, sid: null, title: item.text })
      this.$set(jp, 'isActive', true)
      this.close()
    },

    // --- add/remove ---
    addJoin() {
      if (!this.value.joins) this.$set(this.value, 'joins', [])
      this.value.joins.push({
        isActive: false,
        join: { value: null, sid: null, title: null },
      })
    },
    removeJoin(i) { this.value.joins.splice(i, 1); if (this.activeRow === i) this.close() },

    // --- load ref ---
    loadJoinRef() {
      if (cachedJoinRef) { this.joinRef = cachedJoinRef; return }
      if (joinRefLoading) { joinRefCallbacks.push(items => { this.joinRef = items }); return }
      joinRefLoading = true
      useJwt.query({ query: { method: 'entref', param: { entityid: 0, entitysid: 'join' } } })
        .then(r => { if (r.data.thread) this.pollJoinRef(r.data.thread) })
        .catch(() => { joinRefLoading = false })
    },
    pollJoinRef(thread) {
      setTimeout(() => {
        useJwt.query({ query: { method: 'thread', param: { threadname: thread } } })
          .then(r => {
            if (r.data.thread && r.data.thread.status === 'done') {
              const items = (r.data.thread.result.ref || []).map(x => ({ value: x.value, sid: x.sid, title: x.title || `(${x.value})` }))
              cachedJoinRef = items; this.joinRef = items; joinRefLoading = false
              joinRefCallbacks.forEach(cb => cb(items)); joinRefCallbacks = []
            } else { this.pollJoinRef(thread) }
          })
          .catch(() => { joinRefLoading = false })
      }, 500)
    },
  },
}
</script>

<style lang="scss" scoped>
.cj-set {
  font-size: 12px;
}

.cj-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
  user-select: none;
}

.cj-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  cursor: pointer;
}
.cj-dot--on { background: #28c76f; }
.cj-dot--off { background: #ea5455; }

.cj-add {
  font-size: 11px;
  color: #b9b9c3;
  cursor: pointer;
  padding: 1px 4px;
  border-radius: 3px;
  white-space: nowrap;
  &:hover { color: #28c76f; background: rgba(40, 199, 111, 0.1); }
}

.cj-line {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 0 3px 12px;
  line-height: 1.4;
  flex-wrap: wrap;
}

.cj-word {
  color: #7367f0;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  border-bottom: 1px dashed rgba(115, 103, 240, 0.4);
  &:hover { border-bottom-color: #7367f0; }
}

.cj-word--empty {
  color: #b9b9c3;
  border-bottom-color: rgba(185, 185, 195, 0.4);
  font-style: italic;
  &:hover { color: #7367f0; border-bottom-color: #7367f0; }
}

.cj-del {
  color: #b9b9c3;
  cursor: pointer;
  padding: 1px 3px;
  border-radius: 3px;
  line-height: 1;
  flex-shrink: 0;
  &:hover { color: #ea5455; background: rgba(234, 84, 85, 0.1); }
}

.cj-panel {
  position: absolute;
  top: 100%;
  left: 12px;
  z-index: 10;
  width: 220px;
  background: #fff;
  border: 1px solid #ebe9f1;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 4px;
}

.cj-list {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 4px;
}

.cj-opt {
  padding: 3px 8px;
  cursor: pointer;
  border-radius: 3px;
  color: #5e5873;
  &:hover { background: #f8f8f8; }
}

.cj-empty {
  padding: 6px 8px;
  color: #b9b9c3;
}

// Dark mode
.dark-layout {
  .cj-add { color: #4b4b5a; }
  .cj-del { color: #4b4b5a; }
  .cj-word { color: #7367f0; }
  .cj-word--empty { color: #4b4b5a; }
  .cj-panel {
    background: #283046;
    border-color: #3b4253;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
  .cj-opt {
    color: #d0d2d6;
    &:hover { background: #3b4253; }
  }
}
</style>
